"use client"

import NextImage from "@/components/common/NextImage"
import { useProductName } from "@/hooks/product_no_design/useProductName"
import useSelectedAspect from "@/hooks/product_no_design/useSelectedAspect"
import { useSelectedVariant } from "@/hooks/product_no_design/useSelectedVariant"
import { useValidAspects } from "@/hooks/product_no_design/useValidAspects"
import { useAppSelector } from "@/hooks/redux"
import { Col, Row, Tabs } from "antd"
import _ from "lodash"
import { Fragment } from "react"

const ProductNoDesignPreview = () => {
  const productName = useProductName()
  const selectedVariant = useSelectedVariant()
  const { aspect: selectedAspect, onSelect } = useSelectedAspect()
  const defaultImage = useAppSelector(state => state.product.product_no_design.data.default_image)

  const validAspects = useValidAspects()

  if (validAspects.length <= 0) {
    if (!defaultImage) {
      return <Fragment></Fragment>
    }
    return (
      <Row>
        <Col span={24}>
          <NextImage
            src={defaultImage}
            fetchPriority='high'
            width={700}
            height={700}
            style={{ objectFit: 'contain', width: '100%', height: '100%', maxHeight: validAspects.length <= 1 ? "calc(100vh - 8.3rem)" : "calc(100vh - 14.8rem)" }}
            alt={`${productName}`}
          />
        </Col>
      </Row>
    )
  }

  return (
    <Row>
      <Col span={24}>
        <Tabs
          renderTabBar={validAspects.length <= 1 ? () => <></> : undefined}
          onChange={onSelect}
          activeKey={selectedAspect}
          items={validAspects.map(aspect => {
            return {
              label: aspect.split('_').map(w => _.upperFirst(w)).join(' '),
              key: aspect,
              tabKey: aspect,
              children: (
                <NextImage
                  fetchPriority='high'
                  src={((selectedVariant?.images || [])[0] || {})[aspect]}
                  width={700}
                  height={700}
                  style={{ objectFit: 'contain', width: '100%', height: '100%' }}
                  alt={`${productName} - ${(selectedVariant?.attributes || []).map(attr => (attr.color || attr.size)).join(' - ')}`}
                />
              )
            }
          })}
        />
      </Col>
    </Row>
  )
}

export default ProductNoDesignPreview